/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Project_References_OptionalInputs */



/**
* | output |
* | --- |
* | "Optional. You can change this any time from the project page." |
*
* @param {Create_Project_References_OptionalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_references_optional = /** @type {((inputs?: Create_Project_References_OptionalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_References_OptionalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional. Sie können dies jederzeit auf der Projektseite ändern.")
	return /** @type {LocalizedString} */ ("Optional. You can change this any time from the project page.")
});